// extracted by mini-css-extract-plugin
export var closeButton = "CloseButton-module--closeButton--aecb5";